import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  makeStyles,
  IconButton,
  Grid,
  colors,
  TextField,
  Checkbox,
  FormGroup,
  FormControlLabel,
} from "@material-ui/core";


import Button from "../../../../../components/controls/Button";
import { useRef } from "react";
import ReactToPrint from "react-to-print";
import { useEffect } from "react";
import { useStylesLbl, useStylesTD } from "../../../../../St/comps/UseStyle";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useLocalStorage } from "react-use";
import BarcodeNewDesign from "./BarcodeNewDesign";

const useStyles = makeStyles((theme) => ({
  dialog: {
    padding: theme.spacing(2),
    position: "absolute",
    top: theme.spacing(4),
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    alignContent: "center",
    textAlign: "center",
    border: "1px solid #000",
    backgroundColor: "#eee",
  },
  dialogAction: {
    justifyContent: "center",
  },
  titleIcon: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      cursor: "default",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "8rem",
    },
  },
}));

class ComponentNewBarcode extends React.Component {
  state = {
    pwca: true,
  };
  constructor() {
    super();
  }

  render() {
    const styleTyg = {
      color: '#000',
      padding: '0.1mm',
      alignContent: 'center'
    };
    return (
      <Typography component="div" style={styleTyg}>
        <BarcodeNewDesign
          barcode={this.props.barcode}
          itemName={this.props.data.symbol}
          price={this.props.sale_price}
          permiCuCo={this.props.permiCuCo}
          tax={this.props.data.tax}
          AutoOptions={this.props.AutoOptions}
          showItem={this.props.showItem}
          data={this.props.data}
          barcodeOption={this.props.barcodeOption}
          itemCom={this.props.itemCom}

        />
      </Typography>
    );
  }
}


export default function BarcodeGenrateCon(props) {
  const { open, data, setOpen, permiCuCo, barcode, sale_price, AutoOptions, itemCom, type } = props;

  const clasTD = useStylesTD();

  const ComponentNewBarcodes = useRef();

  const classes = useStyles();

  const valueOption = {
    showName: true,
    showPrice: true,
    showDate: false,
    showFound: true,
    showSub: false,
    showImg: false,
    showLogo: false,
    showNumber: false,
    widthCm: 5,
    heightCm: 2.5,
    days: 0,
    datePre: moment(new Date()).format('YYYY-MM-DD'),
    dateEx: moment(new Date()).format('YYYY-MM-DD'),
    omla:'SR'
  }
  // const [barcodeOption, setBarcodeOption] = React.useState(valueOption);
  const [barcodeOption, setBarcodeOption] = useLocalStorage("barcodeOption", valueOption);

  // const [dateData, setDateDate] = React.useState(dataDate);

  const { t } = useTranslation(["forms", "translation"]);
  const onChangeNewData = (propName) => (event) => {
    if (propName === "days") {
      const date = new Date(barcodeOption.datePre);
      const daysD = Number(event.target.value);
      const dy = String(date.getDate()).padStart(2, "0");
      const DayPre = Number(dy);
      date.setDate(date.getDate() + daysD > 0 ? DayPre + daysD : 0);
      // setDateDate({ ...dateData, days: event.target.value, dateEx: moment(date).format('YYYY-MM-DD') });
      setBarcodeOption({ ...barcodeOption, days: event.target.value, dateEx: moment(date).format('YYYY-MM-DD') });
    } else {
      setBarcodeOption({ ...barcodeOption, [propName]: event.target.value });
    }
  };

  const claslbl = useStylesLbl();


  useEffect(() => {
    console.log("the sto is", data);
    console.log("the sale_price is", sale_price);
    console.log("the itemCom is", itemCom);

  });
  const pageStyle = `
  @page {
      size: ${barcodeOption.widthCm}mm 25mm,
  };
  @media all {
      .pageBreak {
          display: none
      }
  };
  
  @media print {
      .pageBreak {
          page-break-before: always;
      }
  }`;

  return (
    <Dialog justifyContent="center" open={open} classes={{ paper: classes.dialog }}>
      <DialogTitle className={classes.dialogTitle}>
        <Typography variant="h5">{t("barcode-print-screen")}</Typography>
        <br />

      </DialogTitle>
      <DialogContent justifyContent="center" className={classes.dialogContent} style={{
        width: "100mm",
        backgroundColor: '#fff', alignContent: "center"
      }}
      >

        <Grid item container lg={12} md={12} sm={12} xs={12}>
          <Grid item lg={5} md={5} sm={5} xs={5} >
            <TextField
              type="number"
              fullWidth
              variant="outlined"
              size="small"
              id="id"
              label={t("label-width")}
              style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
              name="barcode"
              value={barcodeOption.widthCm}
              InputLabelProps={{ className: claslbl.clrBlackLblS }}
              InputProps={{ className: claslbl.clrBlackTxt }}
              onChange={onChangeNewData("widthCm")} />
          </Grid>

          <Grid item lg={5} md={5} sm={5} xs={5} >
            <TextField
              type="number"
              fullWidth
              variant="outlined"
              size="small"
              id="symbol"
              InputLabelProps={{ className: claslbl.clrBlackLblS }}
              InputProps={{ className: claslbl.clrBlackTxt }}
              label={t("label-height")}
              style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
              name="symbol"
              value={barcodeOption.heightCm}
              onChange={onChangeNewData("heightCm")}
            />
          </Grid>


          <Grid item lg={2} md={2} sm={2} xs={2} >
            <TextField
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              id="symbol"
              InputLabelProps={{ className: claslbl.clrBlackLblS }}
              InputProps={{ className: claslbl.clrBlackTxt }}
              label={t("currency")}
              style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
              name="symbol"
              value={barcodeOption.omla}
              onChange={onChangeNewData("omla")}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginBottom: "0.3rem" }} >
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    fullWidth
                    checked={barcodeOption.showPrice}
                    onChange={(e) => {
                      // onChangeNewData("showPrice");
                      setBarcodeOption({ ...barcodeOption, showPrice: e.target.checked });
                    }}
                    name="showLogo"
                  />
                }
                size="small"
                color="primary"
                fontSize="small"
                label={t("show-price")}
                InputLabelProps={{ className: claslbl.clrBlackLbl }}
                InputProps={{ className: clasTD.clrBlackTxt }}
              />
            </FormGroup>
          </Grid>
          <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginBottom: "0.3rem" }} >
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    fullWidth
                    checked={barcodeOption.showName}
                    onChange={(e) => {
                      setBarcodeOption({ ...barcodeOption, showName: e.target.checked });
                    }}
                    name="showName"
                  />
                }
                size="small"
                color="primary"
                fontSize="small"
                label={t("show-name")}
                InputLabelProps={{ className: claslbl.clrBlackLbl }}
                InputProps={{ className: clasTD.clrBlackTxt }}
              />
            </FormGroup>
          </Grid>

          <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginBottom: "0.3rem" }} >
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    fullWidth
                    checked={barcodeOption.showFound}
                    onChange={(e) => {
                      setBarcodeOption({ ...barcodeOption, showFound: e.target.checked });
                    }}
                    name="showFound"
                  />
                }
                size="small"
                color="primary"
                fontSize="small"
                label={t("show-foundation-name")}
                InputLabelProps={{ className: claslbl.clrBlackLbl }}
                InputProps={{ className: clasTD.clrBlackTxt }}
              />
            </FormGroup>
          </Grid>

          <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginBottom: "0.3rem" }} >
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    fullWidth
                    checked={barcodeOption.showNumber}
                    onChange={(e) => {
                      setBarcodeOption({ ...barcodeOption, showNumber: e.target.checked });
                    }}
                    name="showFound"
                  />
                }
                size="small"
                color="primary"
                fontSize="small"
                label={t("show-number")}
                InputLabelProps={{ className: claslbl.clrBlackLbl }}
                InputProps={{ className: clasTD.clrBlackTxt }}
              />
            </FormGroup>
          </Grid>
          {type == 3 &&
            <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginBottom: "0.3rem" }} >
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      fullWidth
                      checked={barcodeOption.showSub}
                      onChange={(e) => {
                        setBarcodeOption({ ...barcodeOption, showSub: e.target.checked });
                      }}
                      name="showLogo"
                    />
                  }
                  size="small"
                  color="primary"
                  fontSize="small"
                  label={t("show-components")}
                  InputLabelProps={{ className: claslbl.clrBlackLbl }}
                  InputProps={{ className: clasTD.clrBlackTxt }}
                />
              </FormGroup>
            </Grid>
          }

          <Grid item lg={4} md={4} sm={4} xs={4} style={{ marginBottom: "0.3rem" }} >
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    fullWidth
                    checked={barcodeOption.useDate}
                    onChange={(e) => {
                      setBarcodeOption({ ...barcodeOption, useDate: e.target.checked });
                    }}
                    name="showLogo"
                  />
                }
                size="small"
                color="primary"
                fontSize="small"
                label={t("use-date")}
                InputLabelProps={{ className: claslbl.clrBlackLbl }}
                InputProps={{ className: clasTD.clrBlackTxt }}
              />
            </FormGroup>
          </Grid>
          {barcodeOption.useDate &&
            (
              <>
                <Grid item lg={8} md={8} sm={8} xs={4} >
                  <TextField
                    // type="date"
                    fullWidth
                    variant="outlined"
                    size="small"
                    id="id"
                    type="date" format="YYYY-MM-DD"
                    InputLabelProps={{ className: claslbl.clrBlackLblS }}
                    InputProps={{ className: claslbl.clrBlackTxt }}
                    label={t("forms:expiry-date")}
                    style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                    name="datePre"
                    value={barcodeOption.datePre}
                    onChange={onChangeNewData("datePre")} />
                </Grid>
                <Grid item lg={4} md={4} sm={4} xs={4} >
                  <TextField
                    type="number"
                    fullWidth
                    variant="outlined"
                    size="small"
                    id="id"
                    InputLabelProps={{ className: claslbl.clrBlackLblS }}
                    InputProps={{ className: claslbl.clrBlackTxt }}
                    label={t("days")}
                    style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                    name="barcode"
                    value={barcodeOption.days}
                    onChange={onChangeNewData("days")} />
                </Grid>
              </>
            )}
        </Grid>

        <div justifyContent="center" className={classes.dialogContent} style={{
          width: barcodeOption.widthCm < 5 ? "50mm" : `${barcodeOption.widthCm}cm`,
          backgroundColor: '#fff', alignContent: "center",
        }}
        >
          <ComponentNewBarcode ref={ComponentNewBarcodes} {...{ data, permiCuCo, barcode, sale_price, AutoOptions, barcodeOption, itemCom }} />
        </div>
        <ReactToPrint justifyContent="center"
          trigger={() => (
            <Button
              text={t("print")}
              size="small"
              color="secondary"
              variant="outlined"
            />
          )}
          content={() => ComponentNewBarcodes.current}
          pageStyle={pageStyle}
        />

      </DialogContent>
      <DialogActions className={classes.dialogAction}>
        <Button text={t("close")} color="secondary" onClick={() => setOpen(false)} />
        <ReactToPrint
          trigger={() => <Button text={t("print")} color="secondary" />}
          content={() => ComponentNewBarcodes.current}
        />
      </DialogActions>
    </Dialog>
  );
}
